<app-custom-multi-select
  [(ngModel)]="manageService.selectedServers"
  (ngModelChange)="onSelectChange()"
  [options]="manageService.servers"
  bindLabel="label"
  bindValue="value"
  [multiple]="true"
  placeholder="Select server">
</app-custom-multi-select>
